import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <HashRouter>
            <App />
        </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//disable right click
// document.addEventListener('contextmenu', event => event.preventDefault());
 
// document.onkeydown = function (e) {
 
//     // disable F12 key
//     if(e.keyCode === 123) {
//         return false;
//     }
 
//     // disable I key
//     if(e.ctrlKey && e.shiftKey && e.keyCode === 73){
//         return false;
//     }
 
//     // disable J key
//     if(e.ctrlKey && e.shiftKey && e.keyCode === 74) {
//         return false;
//     }
 
//     // disable U key
//     if(e.ctrlKey && e.keyCode === 85) {
//         return false;
//     }
// }